//常量集合，存放不同action的type值
export const CHANGE_BANNER = "recommend/CHANGE_BANNER";
export const CHANGE_RECOMMEND_LIST = "recommend/RECOMMEND_LIST"; 
export const CHANGE_ENTER_LOADING = "recommend/CHANGE_ENTER_LOADING"; 